import React from 'react';
import { observer } from 'mobx-react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import withStores from '@studionand/ada-next/src/stores/withStores';

const WelcomeAfterLogin = props => {
  const { loginStore } = props;

  const handleLogout = () => {
    loginStore.logoutAsync();
  };

  return (
    <React.Fragment>
      <Typography align="center" variant="body1" gutterBottom>
        Willkommen <b>{loginStore.currentUser.name}</b>.
      </Typography>
      <Typography align="center" variant="body1">
        Sie haben sich erfolgreich angemeldet.
      </Typography>
      <Box mt={4} textAlign="center">
        <Button variant="text" size="medium" onClick={handleLogout}>
          Logout
        </Button>
      </Box>
    </React.Fragment>
  );
};

export default withStores('loginStore')(observer(WelcomeAfterLogin));
